const $ = jQuery;

const news = {
    ppp: 4,
    $loading: $('.news-section .loading'),
    $ajaxContainer: $("#ajax-news-container"),

    init() {
        this.infiniteScroll();
    },

    infiniteScroll() {
        let startPage = 2;
        let total = ajaxInfo.total_posts;
        const numPages = Math.round(total / this.ppp);

        $(window).scroll(function () {
            if ( $(window).scrollTop() === $(document).height() - $(window).height() ) {

                if ( startPage > numPages ) {
                    return false;
                } else {
                    news.loadArticle(startPage);
                }
                startPage++;
            }
        });

    },

    loadArticle(pageNumber) {

        $.ajax({
            url: ajaxInfo.adminUrl + "/admin-ajax.php",
            type: 'POST',
            data: "action=ajax_load_more_news&ppp="+news.ppp+"&page_no=" + pageNumber,
            beforeSend: function() {
                news.$loading.show();
            },
            success: function(html) {
                news.$loading.fadeOut(500);

                $(html).appendTo("#ajax-news-container").fadeIn('slow', function () {
                    $(this).animate({borderSpacing: 0}, {
                        step: function (now, fx) {
                            $(this).css({'opacity':'1', 'transform':'none'});
                        },
                        duration: 'slow'
                    }, 'linear');
                });
            }
        });
        return false;
    }

};

news.init();